const features = [
  {
    id: 1,
    title: '全部免费',
    desc: '九妖漫画网所有漫画资源完全免费阅读，无需付费订阅，没有隐藏收费，让每一位漫画爱好者都能畅享阅读乐趣。',
    icon: 'ri-vip-crown-line',
  },
  {
    id: 2,
    title: '极速下拉式',
    desc: '采用创新的下拉式连续阅读模式，告别翻页等待，屏幕无缝衔接，沉浸式追更体验流畅如丝，一口气读完一整话。',
    icon: 'ri-scroll-to-bottom-line',
  },
  {
    id: 3,
    title: '高清无删减',
    desc: '漫画画面高清呈现，原版无删减内容完整保留，细节清晰可见，还原漫画作者最初的创作意图与艺术表达。',
    icon: 'ri-hd-line',
  },
  {
    id: 4,
    title: '智能追更提醒',
    desc: '收藏喜欢的漫画后自动追踪更新状态，最新章节上线即时通知，不错过任何一话精彩内容，追更就是这么省心。',
    icon: 'ri-notification-3-line',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            为什么选择九妖漫画网
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            四大核心优势，为您打造极致的免费漫画阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feat) => (
            <div
              key={feat.id}
              className="group p-6 md:p-7 rounded-2xl bg-background-50 hover:bg-background-50 transition-colors cursor-default"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 text-xl mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={feat.icon}></i>
              </span>
              <h3 className="font-heading font-bold text-base text-foreground-900 mb-2">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}